export default {
  ru: {
    messages: {
      min: (_, value) => `Минимальная длина — ${ value } знаков.`,
      max: (_, value) => `Максимальная длина — ${ value } знаков.`,
      required: 'Это обязательное поле.',
      email: 'Неверно введён E-mail.',
      url: 'Неверно введён URL.',
      confirmed: 'Поля не совпадают.',
      decimal: 'Допустимы только числа (десятичные).',
      between: (_, value) => `Значение должно быть между ${value}`,
      alpha_dash: 'Допустимы только буквы и знаки "-" и "_"'
    }
  }
}
